// extracted by mini-css-extract-plugin
module.exports = {"arrowWrapper":"SwitchArrow_arrowWrapper__3ZDDr"};